var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "#787F99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 177.853V184.9C176 193.205 169.205 200 160.9 200H40.1C31.795 200 25 193.205 25 184.9V177.853C25 159.482 46.3917 148.408 66.525 139.6C67.28 139.348 67.7833 139.097 68.5383 138.593C70.0483 137.838 71.81 137.838 73.32 138.845C81.3733 144.13 90.685 147.15 100.5 147.15C110.315 147.15 119.627 144.13 127.68 139.097C129.19 138.09 130.952 138.09 132.462 138.845C133.217 139.097 133.72 139.348 134.475 139.852C154.608 148.408 176 159.482 176 177.853V177.853Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 132.05C121.21 132.05 137.998 113.459 137.998 90.525C137.998 67.5914 121.21 49 100.5 49C79.7902 49 63.0016 67.5914 63.0016 90.525C63.0016 113.459 79.7902 132.05 100.5 132.05Z",
    fill: "#B1B1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.5bf9c73aaa932cb698a1e25c9a0d15ba.svg";
export { ForwardRef as ReactComponent };